import React from 'react';
import { Form } from 'react-bootstrap';
import Permiso from './Permiso';
import PropTypes from 'prop-types';

const Permisos = ({ rol, name, permissions, handleSwitch }) => {
  return (
    <>
      <Form.Label>
        <strong>{name}</strong>
      </Form.Label>

      {permissions.map((permiso, index) => {
        return (
          <Permiso
            key={index}
            rol={rol}
            permiso={permiso}
            handleSwitch={handleSwitch}
          />
        );
      })}
    </>
  );
};

Permisos.propTypes = {
  rol: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  permissions: PropTypes.array.isRequired,
  handleSwitch: PropTypes.func.isRequired
};

export default Permisos;
